import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 568.000000 568.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,568.000000) scale(0.100000,-0.100000)">
<path d="M2665 5664 c-438 -42 -746 -124 -1071 -287 -302 -151 -513 -303 -749
-541 -197 -197 -339 -381 -464 -601 -205 -362 -325 -751 -361 -1170 -13 -164
-12 -311 5 -495 44 -473 206 -923 478 -1325 99 -147 296 -378 403 -471 37 -33
76 -68 88 -79 73 -70 306 -236 426 -304 450 -253 855 -366 1352 -378 350 -9
615 29 943 133 61 19 119 39 130 44 11 5 43 18 72 29 122 47 391 193 528 286
173 117 422 343 558 505 72 87 194 256 254 355 62 100 174 318 188 365 4 14
11 30 15 35 25 35 110 304 145 465 51 231 59 316 60 610 0 286 -7 358 -56 590
-86 405 -272 808 -523 1130 -69 89 -261 305 -294 331 -15 11 -45 37 -67 57
-173 160 -470 357 -685 456 -252 115 -559 204 -835 241 -114 15 -455 27 -540
19z m591 -63 c181 -27 386 -80 551 -141 142 -53 361 -153 423 -194 19 -12 80
-51 135 -87 519 -332 923 -853 1123 -1444 158 -467 188 -954 91 -1450 -51
-259 -122 -463 -246 -710 -268 -533 -696 -960 -1234 -1231 -350 -177 -674
-264 -1096 -295 -215 -16 -414 -2 -715 50 -92 16 -285 70 -403 113 -129 47
-169 65 -290 126 -49 25 -103 52 -120 60 -66 33 -289 186 -387 264 -163 131
-366 340 -479 493 -41 57 -65 91 -155 230 -147 223 -292 598 -352 906 -41 209
-47 279 -47 554 1 334 20 477 110 798 19 69 125 350 134 357 4 3 15 25 24 50
9 25 27 61 39 80 11 19 34 59 50 88 32 61 180 284 234 352 73 92 195 223 305
326 139 130 406 323 544 391 22 11 66 34 99 52 32 17 64 31 72 31 8 0 14 4 14
8 0 5 15 14 33 19 17 6 86 32 151 57 199 77 486 143 741 170 22 2 148 3 280 1
176 -3 275 -9 371 -24z"/>
<path d="M2715 5408 c-2 -7 -9 -92 -16 -188 -6 -96 -15 -215 -19 -265 -3 -49
-5 -93 -3 -96 5 -11 204 -22 213 -13 5 5 12 69 16 142 4 72 10 132 13 132 3 0
22 -25 41 -55 19 -30 37 -54 40 -54 3 0 23 23 45 52 l40 52 3 -37 c2 -21 -1
-86 -7 -145 -5 -59 -9 -108 -8 -109 1 -1 53 -5 115 -9 l112 -8 0 54 c0 30 7
128 14 219 8 91 16 194 17 230 l3 65 -104 8 -105 8 -53 -56 c-29 -30 -54 -55
-56 -55 -2 0 -22 29 -44 64 l-41 63 -77 7 c-109 9 -134 8 -139 -6z"/>
<path d="M2262 5340 c-153 -40 -222 -121 -194 -227 24 -87 48 -108 168 -143
70 -20 89 -35 78 -64 -13 -33 -103 -26 -147 12 -9 8 -19 13 -21 11 -2 -2 -6
-43 -9 -90 -6 -83 -5 -87 16 -93 66 -17 218 7 304 50 95 46 133 129 99 218
-28 72 -80 107 -184 121 -65 9 -102 35 -86 62 17 28 87 29 130 2 19 -12 37
-20 38 -18 2 2 7 40 11 85 7 79 6 81 -17 87 -41 12 -111 6 -186 -13z"/>
<path d="M3556 5028 l-195 -222 54 -22 c31 -13 76 -33 100 -45 l46 -23 32 37
c18 20 35 37 39 37 4 0 39 -14 78 -31 l70 -32 0 -52 0 -53 76 -36 c92 -43 124
-53 124 -36 0 16 58 497 65 538 6 32 6 33 -77 71 -134 62 -200 91 -209 91 -4
0 -96 -100 -203 -222z m259 -85 c-4 -38 -10 -71 -14 -76 -4 -4 -24 1 -45 11
l-37 18 47 57 c25 31 49 57 51 57 3 0 2 -30 -2 -67z"/>
<path d="M1513 5015 c-99 -30 -183 -101 -215 -178 -54 -133 20 -312 157 -382
105 -53 212 -36 312 50 48 40 110 133 97 144 -5 4 -49 31 -98 61 -87 52 -89
53 -105 34 -48 -58 -114 -81 -141 -50 -19 24 9 68 65 98 28 15 49 31 49 35 -1
5 -9 52 -19 106 -19 109 -19 109 -102 82z"/>
<path d="M4330 4842 c-35 -42 -71 -84 -80 -93 -41 -41 -215 -252 -215 -260 0
-10 145 -139 157 -139 3 0 25 24 49 53 70 86 88 101 104 87 30 -25 16 -75 -51
-188 l-19 -32 35 -27 c19 -15 56 -47 82 -72 56 -51 62 -49 101 32 23 47 37 90
52 170 4 22 11 27 33 27 60 0 142 92 142 160 0 66 -30 107 -160 220 -41 35
-77 67 -80 70 -3 3 -23 20 -46 37 l-41 32 -63 -77z m189 -186 c17 -44 -24 -84
-76 -74 -30 6 -25 31 13 70 38 40 50 40 63 4z"/>
<path d="M2600 4685 c-278 -40 -540 -129 -755 -254 -33 -20 -62 -38 -65 -42
-3 -3 -16 -12 -30 -19 -14 -7 -52 -34 -85 -59 -33 -25 -69 -52 -80 -61 -80
-59 -385 -396 -385 -425 0 -3 -15 -28 -34 -57 -127 -200 -220 -465 -256 -731
-15 -115 -12 -354 6 -475 39 -267 138 -538 264 -722 5 -8 31 -46 56 -84 25
-38 51 -75 57 -82 7 -6 46 -50 87 -96 178 -198 421 -375 662 -479 757 -330
1633 -171 2207 399 243 241 396 495 489 813 53 181 66 282 66 509 0 172 -3
223 -22 315 -55 279 -142 487 -295 713 -288 426 -743 720 -1264 818 -173 32
-471 42 -623 19z m580 -48 c455 -80 840 -295 1150 -642 48 -54 124 -154 140
-185 7 -14 16 -27 19 -30 33 -27 153 -286 205 -440 65 -196 94 -543 62 -759
-18 -123 -49 -262 -71 -320 -74 -197 -132 -317 -208 -431 -280 -422 -695 -703
-1207 -821 -171 -39 -499 -51 -687 -24 -417 59 -794 241 -1086 524 -256 248
-420 532 -513 888 -59 225 -58 614 1 843 51 198 143 405 248 562 93 139 118
169 249 299 207 208 436 351 724 453 133 47 233 69 449 100 66 9 444 -3 525
-17z"/>
<path d="M2599 3280 c-157 -26 -236 -68 -276 -144 -22 -43 -20 -894 3 -937 29
-58 120 -103 259 -130 80 -15 462 -19 510 -5 29 8 28 9 -55 50 l-85 41 -1 40
c-1 29 -5 39 -15 36 -41 -11 -62 -13 -94 -7 l-35 7 0 440 0 439 28 11 c17 7
42 7 67 2 l40 -8 3 -128 3 -127 224 0 225 0 0 129 c0 71 -4 140 -9 153 -22 59
-102 108 -217 134 -108 25 -440 27 -575 4z"/>
<path d="M893 4510 l-62 -88 22 -66 c26 -81 22 -86 -68 -86 -45 0 -64 -4 -76
-17 -31 -37 -109 -151 -109 -159 1 -5 33 -31 73 -57 65 -44 257 -180 316 -224
60 -46 69 -49 85 -28 76 100 109 156 98 167 -6 6 -55 41 -108 78 -53 36 -97
70 -98 76 0 5 27 10 62 12 34 2 62 4 62 6 0 1 -7 26 -16 55 -8 29 -14 57 -12
62 3 9 83 -43 181 -118 22 -17 44 -30 48 -27 4 2 34 42 68 89 l61 85 -73 50
c-39 28 -83 60 -97 70 -32 24 -272 194 -285 202 -6 3 -38 -33 -72 -82z"/>
<path d="M4885 4379 c-16 -11 -60 -38 -97 -60 -60 -35 -84 -59 -60 -59 5 0 18
-18 31 -40 l22 -40 -130 -85 c-72 -47 -131 -88 -131 -91 0 -15 104 -174 113
-174 13 0 234 137 242 151 12 19 31 8 59 -36 l28 -46 32 19 c189 115 183 110
158 143 -10 13 -56 85 -102 159 -127 204 -115 193 -165 159z"/>
</g>
</svg>

    </Box> 
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
